'use client'

import _ from 'lodash'
import { twMerge } from 'tailwind-merge'
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { ChevronUpDownIcon } from '@heroicons/react/20/solid'
import React from 'react'

type ListBoxProps = {
  label?: string | React.ReactNode
  option: {
    popular?: string[],
    other?: string[],
    all?: string[]
  }
  allowAny?: boolean
  value?: any
  onChange: (val: number) => void
  optional?: boolean
  disabled?: boolean
} & (React.ComponentPropsWithoutRef<'select'>)

export function MakeModelListBox(props: ListBoxProps) {
  const { label, option, allowAny, value, onChange, disabled } = props
  const errMsg = _.get(props, 'data-error')
  const hasPopular = !_.isEmpty(option?.popular)
  const hasOther = !_.isEmpty(option?.other)
  return (
    <Listbox value={value} onChange={(val) => onChange(val)} disabled={disabled || false}>
      <div>
        {
          label && <label className='form-label'>{label}</label>
        }
        <div className={twMerge('relative w-full', label && 'mt-1')}>
          <ListboxButton className='form-listbox md:h-9! text-left rounded pr-10'>
            <span className='block truncate md:text-sm md:font-medium pr-8'>
              {value}
            </span>
            <span className='form-input-icon'>
              <ChevronUpDownIcon aria-hidden='true' className='size-5 text-stone-400' />
            </span>
          </ListboxButton>
          <ListboxOptions transition className='form-options'>
            {
              allowAny &&
              <ListboxOption value={''} className='form-option'>
                <span className='block truncate font-normal group-data-selected:font-semibold'>Any</span>
              </ListboxOption>
            }
            {
              hasPopular &&
              <>
                {
                  hasOther &&
                  <div className='form-option-name'>
                    Popular:
                  </div>
                }
                {_.map(option?.popular, (val, idx) => (
                  <ListboxOption key={idx} value={val} className={twMerge('form-option mr-4 rounded', hasOther && 'ml-4')}>
                    <span className='block truncate font-normal group-data-selected:font-semibold'>{val}</span>
                  </ListboxOption>
                ))}
              </>
            }
            {
              hasOther &&
              <>
                {
                  hasPopular &&
                  <div className='form-option-name'>
                    Other:
                  </div>
                }
                {_.map(option?.other, (val, idx) => (
                  <ListboxOption key={idx} value={val} className={twMerge('form-option mr-4 rounded', hasPopular && 'ml-4')}>
                    <span className="block truncate font-normal group-data-selected:font-semibold">{val}</span>
                  </ListboxOption>
                ))}
              </>
            }
            {
              !_.isEmpty(option?.all) &&
              _.map(option?.all, (val, idx) => (
                <ListboxOption key={idx} value={val} className='form-option rounded py-1!'>
                  <span className='block truncate font-normal group-data-selected:font-semibold'>{val}</span>
                </ListboxOption>
              ))
            }
          </ListboxOptions>
        </div>
        {
          errMsg && <div className='form-error-message'>{errMsg}</div>
        }
      </div>
    </Listbox >
  )
}